<div id="book-appointment" class="right-nav" *ngIf="!isWellnessPackageCoupon">
  <div class="component">
    <ng-container>
      <ng-container>
        <div class="header border-bottom">
          <div class="font-primary-title bold" *ngIf="flowType === 'WELLNESS'">{{ 'title_health_chkup_wellness_pkgs'|translate:'LABELS'}} </div>
          <div class="font-primary-title bold" *ngIf="flowType === 'PROMO'">{{ 'title_health_chkup_promo_pkgs'|translate:'LABELS'}} </div>
          <div (click)="closeModal()" class="float-right closeicon pointer">
            <img src="./assets/icons/close_black.svg">
          </div>
        </div>
        <div class="modal-pkg-content">
          <div class="filter-section">
            <div class="search" id="search-static">
              <img class="type-image" src="./assets/icons/Book_new/search.svg">
              <input type="text" [(ngModel)]="searchkey" placeholder="{{'plhd_search_package'|translate}}">
              <img class="close-icon cursor-pointer" src="assets/icons/close_grey.svg" *ngIf="searchkey"
                (click)="searchkey=''">
            </div>
            <div class="filter-template">
              <div class="filter-icon show" (click)="openFilterModal($event)">
                <img class="type-image" src="assets/icons/health-package/Filter.svg">
              </div>
            </div>

            <div class="flex-container" *ngIf="false">
              <div class="group">
                <div class="label">
                  <label class="font-light-xssmall">{{'lbl_choose_facility' | translate }}</label>
                </div>
                <div class="inputs ">
                  <div class="input-group select-input">
                    <div class="location-input" (click)="searchFacility.show = !searchFacility.show">
                      <div class="image hide">
                        <img class="type-image" src="assets/icons/current.svg" alt="">
                      </div>
                      <div class="value  font-default-small">
                        <!-- {{searchFacility.selected['facilityName'] | translate : 'LOCALE' : 'name'}} -->
                        {{(searchFacility.selected['facilityId']|facilityDetails:'facilityName') | translate : 'LOCALE'
                        : 'name'}}
                      </div>
                      <div class="image show">
                        <img src="assets/icons/calendar/drop.svg" alt="">
                      </div>
                    </div>
                    <div class="dropdown" *ngIf="searchFacility.show == true">
                      <div class="dropdown-options">
                        <a class="dropdown-item" *ngFor="let x of facilityList" (click)="selectFacility(x)">
                          <!-- {{x['facilityName'] | translate : 'LOCALE' : 'name'}} -->
                          {{(x['facilityId']|facilityDetails:'facilityName') | translate : 'LOCALE' : 'name'}}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="group" *ngIf=gender.show>
                <div class="label">
                  <label class="font-light-xssmall">{{ 'lbl_select_gender' | translate }}</label>
                </div>
                <div class="flex hide">
                  <div class="radio-option" *ngFor="let item of genderList">
                    <input type="radio" name="label" [checked]="isSelectedGender === item.code ? true: false"
                      (change)="selectGender(item)" [id]="'lang'+item.code">
                    <label class="label" [for]="'lang'+item.code" class="font-default-small">{{item['desc'] |
                      translate}} </label>
                  </div>
                </div>
                <div class="inputs show">
                  <div class="input-group select-input">
                    <div class="location-input" (click)="searchGender = !searchGender">
                      <div class="value  font-default-small">
                        {{ selectedGenderValue | translate}}
                      </div>
                      <div class="image">
                        <img src="assets/icons/calendar/drop.svg" alt="">
                      </div>
                    </div>
                    <div class="dropdown" *ngIf="searchGender == true">
                      <div class="dropdown-options">
                        <a class="dropdown-item" *ngFor="let item of genderList" (click)="selectGender(item)">
                          {{item['desc'] | translate}}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="speciality-grp">
            <div class="speciality-label">
              {{'speciality_filter' | translate:'LABELS'}}
            </div>
            <div class="filterRow">
              <ng-container *ngFor="let group of applicableFilter">
                <ng-container *ngIf="group.showInFilterRow">
                  <ng-container *ngFor="let option of group.options">
                    <div class="option-parent" [ngClass]="{ selected: option.selected }"
                      (click)="toggleSelection(group.type, option.key)">
                      <div class="icon-container ion-activatable ripple-parent">
                        <!-- <img [src]="option.icon" alt="{{ option.label | translate }}" /> -->
                        <img *ngIf="option.key != 'UNKNOWN'" [src]="option.icon" />
                        <img *ngIf="option.key == 'UNKNOWN' && flowType == 'WELLNESS'"
                          src="assets/icons/packages/wellnesscardicon.svg">
                        <img *ngIf="option.key == 'UNKNOWN' && flowType == 'PROMO'"
                          src="assets/icons/packages/promopackage.svg">
                        <p>
                          <text [color]="option.selected ? 'primary' : 'black'">
                            {{ option.label | translate }}
                          </text>
                        </p>
                        <ion-ripple-effect></ion-ripple-effect>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
            </div>
          </div>
          <div class="package-section" *ngIf="loadedContent" #packageScroll>
            <div class="cards"
              *ngIf="((packageList | healthpack : applicableFilter : filterAsModal: timestamp) | filterSearch : searchkey : 'name': 'LANGARRAY' : 'name') as packResult">
              <ng-container *ngIf="packResult?.length > 0; else NORESULT">
                <div class="card-layout" *ngFor="let c of packResult">
                  <div class="card row cursor-pointer" (click)="getSelectedPackageDetail(c)">
                    <div class="image">
                      <ng-container *ngIf="c.detail | translate : 'LANGARRAY' : 'imageURL'; else DFLTIMG">
                        <img class="type-image" [src]="c.detail | translate : 'LANGARRAY' : 'imageURL'" alt="">
                      </ng-container>
                      <ng-template #DFLTIMG>
                        <img class="type-image" src="assets/icons/health-package/healthpack_dflt.png" alt="">
                      </ng-template>
                    </div>
                    <div class="card-content font-default-subtitle">
                      <div>
                        <p class="font-default-subtitle bold">{{c.name | translate : 'LANGARRAY' : 'name'}}</p>
                      </div>
                      <div class="font-primary-subtitle bold clmn">
                        <span *ngIf="getDiscountChargeByFacility(c)">{{getDiscountChargeByFacility(c)}}
                          {{currency_code}}
                        </span>
                        <span *ngIf="getChargeByFacility(c)"
                          [ngClass]="{ 'lstrike' : getDiscountChargeByFacility(c) }">{{getChargeByFacility(c)}}
                          {{currency_code}} </span>
                      </div>
                    </div>
                    <ng-container *ngIf=" (c | translate : 'MODEOFSERVICE') as modeOfService">
                      <div class="service-avail-con" *ngIf="!hideHHCNav">
                        <div class="service-con clinic" *ngIf="modeOfService.includes('CLINIC') && !hideClinicOptFromModeOfService">
                          <img src="assets/icons/packages/clinicgreen.svg">
                          <p>{{ "HEALTH_PKG#LABEL#AVAILATCLINIC" | translate}}</p>
                        </div>
                        <div class="service-con home" *ngIf="modeOfService.includes('HOMECARE') && !hideHomeVideoOptFromModeOfService">
                          <img src="assets/icons/packages/homechip.svg">
                          <p>{{ "HEALTH_PKG#LABEL#AVAILATHOME" | translate}}</p>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </ng-container>
              <ng-template #NORESULT>
                <!-- <div class="no-result-container">
                  <div class="center no-result-icon">
                    <img src="./assets/icon/no-data.svg" alt="">
                  </div>
                  <ion-label>
                    <h4><strong>{{'NO_PACKAGE_FOUND_TITLE' | translate}}</strong></h4>
                    <p>{{'NO_PACKAGE_FOUND_SUBTITLE' | translate}}</p>
                  </ion-label>
                </div> -->
              </ng-template>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="hideHealthPackages && !openPkgReq && false">
        <app-health-package-details [selectedPkg]="selectedPkg" (closePkg)="closePkgDetail()"
          (openRequest)="openConfirm($event)" (action)="checkAction($event)"></app-health-package-details>
      </ng-container>
      <ng-container *ngIf="openPkgReq && false">
        <app-health-package-confirm-request [pkgPrefer]="userPkgPeferrence" [reqConfirm]="reqConfirm"
          (close)="closeModal()"></app-health-package-confirm-request>
      </ng-container>
      <ng-container *ngIf="isShowExternalFilter">
        <app-package-filter-modal [filters]="applicableFilter" (close)="isShowExternalFilter=false"
          (applyFilters)="filterPackages($event)"></app-package-filter-modal>
      </ng-container>
    </ng-container>
    <div *ngIf="false">
      <app-filter [filterInput]="applicableFilter" (close)="filterPackages($event)"
        [isShowExternalFilter]="isShowExternalFilter" (showExternalFilter)="openFilterModal($event)"></app-filter>
    </div>
  </div>
</div>